<template>
  <div class="bg">
    <div class="container">
      <img src="../assets/logo.png" class="logo" />
      <form class="box-container" @submit.prevent="submit" v-if="!$store.state.coach">
        <p>Forgot Your Password?</p>
        <input type="email" placeholder="Email" v-model="email" />
        <p v-if="error" class="error-msg">{{ error }}</p>
        <p
          v-if="success"
          class="success-msg"
        >We sent an email to {{emailForLabel}}. Click the link in that email to reset your password.</p>
        <button type="submit">Recover</button>
      </form>
      <!-- <div class="signup">
        Don't have an account?
        <a @click="$router.push('/signup')">Sign Up</a>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      emailForLabel: "",
      error: "",
      success: false
    };
  },
  methods: {
    submit() {
      this.$store
        .dispatch("recoverPassword", this.email)
        .then(res => {
          console.log(res);
          this.emailForLabel = this.email.slice();
          this.email = "";
          this.success = true;
        })
        .catch(err => {
          console.log(err);
          this.success = false;
          this.error = err.message;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
p.error-msg {
  border: 1px solid #cf202a;
  padding: 10px;
  font-size: 14px;
  line-height: 1.3;
  font-weight: 500;
  color: black;
  text-align: left;
}

p.success-msg {
  border: 1px solid #388e3c;
  padding: 10px;
  font-size: 14px;
  line-height: 1.3;
  font-weight: 400;
  color: black;
  text-align: left;
  color: #388e3c;
}

.bg {
  background: url("../assets/bg.png");
  background-size: cover;
  width: 100%;
}
.container {
  max-width: 747px;
  margin: 0 auto;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  padding: 28px;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.39);
}

img.logo {
  width: 100%;
}

form.box-container {
  padding: 50px 30px 20px;
}

form.box-container p:not(.error-msg, .success-msg) {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  color: #707070;
  font-size: 24px;
  text-align: center;
  padding-top: 30px;
  padding-bottom: 30px;
}

form.box-container input {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  width: 100%;
  border: none;
  border-bottom: 1px solid #707070;
  padding: 10px 5px;
  margin-bottom: 30px;
  font-size: 24px;
  line-height: 28px;
  outline: none;
  color: #707070;
}

form.box-container button[type="submit"] {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  background: #005fa8;
  width: 226px;
  padding: 8px;
  color: #fff;
  border: none;
  font-size: 28px;
  display: block;
  margin: 0 auto;
  margin-top: 50px;
  cursor: pointer;
  border-radius: 5px;
  box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.5);
}

form.box-container .forgot-link {
  color: #0063ae;
  text-align: center;
  display: block;
  text-decoration: none;
  padding-top: 20px;
  font-size: 21px;
}

.signup {
  color: #707070;
  text-align: center;
  display: block;
  text-decoration: none;
  font-size: 21px;
  padding-top: 100px;
}

.signup a {
  color: #0063ae;
  text-decoration: none;
}
</style>
